export class EmergencyClass {
  static NL = "NL";
  static AL = "AL";
  static SE = "SE";
  static GE = "GE";
  static FN = "FN";
  static NAMES = {
    NL: "",
    AL: "警戒事態",
    SE: "施設敷地緊急事態",
    GE: "全面緊急事態",
    FN: "終結"
  };
  static SHORT_NAMES = {
    NL: "",
    AL: "ＡＬ",
    SE: "ＳＥ",
    GE: "ＧＥ",
    FN: "終結"
  };
  constructor(value) {
    this.value = value;
  }
  static factory(value = EmergencyClass.NL) {
    return new EmergencyClass(value);
  }
  static list() {
    return Object.entries(EmergencyClass.NAMES)
      .map(([key, value]) => ({
        emergencyClass: key,
        name: value,
        shortName: EmergencyClass.SHORT_NAMES[key]
      }))
      .filter(obj => obj.emergencyClass !== EmergencyClass.NL);
  }
  // 緊急事態区分のNLを含めたリストを返す
  static listAll() {
    return Object.entries(EmergencyClass.NAMES).map(([key, value]) => ({
      emergencyClass: key,
      name: value,
      shortName: EmergencyClass.SHORT_NAMES[key]
    }));
  }
  toShortName() {
    return EmergencyClass.SHORT_NAMES[this.value];
  }
  toName() {
    if (this.value === EmergencyClass.NL || this.value === EmergencyClass.FN) {
      return this.toShortName();
    }
    return `${this.toShortName()}：${EmergencyClass.NAMES[this.value]}`;
  }
  toNameForEvacueeStatus() {
    return EmergencyClass.NAMES[this.value];
  }
  isNl() {
    return this.value === EmergencyClass.NL;
  }
  isAl() {
    return this.value === EmergencyClass.AL;
  }
  isSe() {
    return this.value === EmergencyClass.SE;
  }
  isGe() {
    return this.value === EmergencyClass.GE;
  }
  isFn() {
    return this.value === EmergencyClass.FN;
  }
}
